import FormCheckBox from '@/views/components/Inputs/FormCheckBox';
import TrailerStoreIdSelector from '@/views/components/Selectors/TrailerStoreIdSelector';
import { DEFAULT_PARAMS, excludedStatuses } from '@/views/pages/Savers/trailer-request.constants';
import { Col, Form, Row } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAllLocationsEffect,
  getAllNewUnitSizeIdEffect,
  getAllStatusEffect,
  getAllSupplyLocationIDEffect,
  getAllTrailerStatusEffect,
  getAllUnitRentalCompanyIdEffect,
  getAllYardEffect,
  getTrailersListEffect,
  saveTrailer,
  updateTrailerNote,
  updateTrailerStatus,
} from '../../../redux/Savers/SaversEffects';
import { setAppLoader } from '../../../redux/common/CommonActions';
import FormInput from '../../components/Inputs/FormInput';
import FormSelectBox from '../../components/Inputs/FormSelectBox';
import FormTextArea from '../../components/Inputs/FormTextArea';
import PrimaryLabel from '../../components/Labels/PrimaryLabel';
import AlertModal from '../../components/Modals/AlertModal';
import Drawer from '../../components/Modals/Drawer';

const TrailerSearch = ({ branchKey, onGeneralSearch, onSearchClick, isModal, status }) => {
  const dispatch = useDispatch();

  const [formNewTrailer] = Form.useForm();
  const [formUpdateTrailer] = Form.useForm();
  const [formIssueTrailer] = Form.useForm();
  const [formStatusTrailer] = Form.useForm();
  const [hidden, setHidden] = useState(false);
  const [updateTrailerHidden, setUpdateTrailerHidden] = useState(false);
  const [issueHidden, setIssueHidden] = useState(false);
  const [statusHidden, setStatusHidden] = useState(false);
  const [trailerStatusOptions, setTrailerStatusOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [trailerNumberOptions, setTrailerNumberOptions] = useState([]);
  const [trailerNumber, setTrailerNumber] = useState(0);
  const [trailerLocationIdOptions, setTrailerLocationIdOptions] = useState([]);
  const [tempTrailerLocationIdOptions, setTempTrailerLocationIdOptions] = useState([]);
  const [trailerYardOptions, setTrailerYardOptions] = useState([]);

  const [unitRentalCompanyIdOptions, setUnitRentalCompanyIdOptions] = useState([]);
  const [unitSizeIdOptions, setUnitSizeIdOptions] = useState([]);

  const { selectedCompany } = useSelector((state) => state.auth);
  const [inputTrailerNumber, setInputTrailerNumber] = useState('');
  const [selectedTrailerId, setSelectedTrailerId] = useState('');
  const [selectedTrailerLocationId, setSelectedTrailerLocationId] = useState('');
  const [selectedTrailerYard, setSelectedTrailerYard] = useState('');
  const [selectedFreightCarrierId, setSelectedFreightCarrierId] = useState('0');

  const [selectedFreightCommodityId, setSelectedFreightCommodityId] = useState('0');
  const [selectedUnitRentalCompanyId, setSelectedUnitRentalCompanyId] = useState('');
  const [selectedUnitSizeId, setSelectedUnitSizeId] = useState('');
  const [selectedStatusId, setSelectedStatusId] = useState('');
  const [selectedTrailerStatusId, setSelectedTrailerStatusId] = useState('');
  const [selectedTrailerNote, setSelectedTrailerNote] = useState('');
  const [isOutOfService, setIsOutOfService] = useState(false);
  const [selectedTrailerData, setSelectedTrailerData] = useState('');
  const [selectedTrailerIssueData, setSelectedTrailerIssueData] = useState('');
  const [selectedTrailerStatusData, setSelectedTrailerStatusData] = useState('');

  const [searchStatusId, setSearchStatusId] = useState('');
  const [searchTrailerId, setSearchTrailerId] = useState('');
  const [supplyZone, setSupplyZone] = useState('');
  const [searchLocationId, setSearchLocationId] = useState(branchKey);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [trailerError, setTrailerError] = useState('');
  const [supplyZoneNumberOptions, setSupplyZoneNumberOptions] = useState([]);

  useEffect(() => {
    getTrailerList();
    getAllTrailerLocationID();
    getAllUnitRentalCompanyID();
    getAllUnitSizeID();
    getAllYard();
    getAllTrailerStatus();
    getAllStatus();
    getAllDropDownOptions();
  }, [selectedCompany]);

  const onTrailerNumberInput = (e) => {
    setInputTrailerNumber(e.target.value);
  };

  const onChangeGeneralSearch = (e) => {
    onGeneralSearch(e.target.value);
  };

  useEffect(() => {
    if (selectedTrailerData && selectedTrailerData.length > 0) {
      setInputTrailerNumber(selectedTrailerData[0].trailerNumber);
      setSelectedTrailerLocationId(selectedTrailerData[0].locationId);
      setSelectedTrailerYard(selectedTrailerData[0].yardID);
      setSelectedFreightCarrierId(selectedTrailerData[0].freightCarrierID);
      setSelectedUnitSizeId(selectedTrailerData[0].unitSizeID);
      setSelectedFreightCommodityId(selectedTrailerData[0].freightCommodityID);
      setSelectedUnitRentalCompanyId(selectedTrailerData[0].freightCommodityID);
      setTempTrailerLocationIdOptions(
        trailerLocationIdOptions.filter((option) => option.value === selectedTrailerData[0].locationId),
      );
      setSelectedStatusId(selectedTrailerData[0].status);

      formUpdateTrailer.setFieldsValue({
        UpdateTrailerLocationId: selectedTrailerData[0]?.locationId,
        UpdateTrailerYard: selectedTrailerData[0]?.yardID,
        UpdateUnitSizeId: selectedTrailerData[0]?.unitSizeID,
        UpdateUnitRentalCompanyId: selectedTrailerData[0]?.unitRentalCompanyID,
        UpdateStatus: selectedTrailerData[0]?.status,
      });
    }
  }, [selectedTrailerData]);

  useEffect(() => {
    if (selectedTrailerIssueData && selectedTrailerIssueData.length > 0) {
      setSelectedTrailerNote(selectedTrailerIssueData[0].trailerNotes);
      formIssueTrailer.setFieldsValue({
        inpTrailerIssue: selectedTrailerIssueData[0]?.trailerNotes,
      });
    }
  }, [selectedTrailerIssueData]);

  useEffect(() => {
    if (selectedTrailerStatusData && selectedTrailerStatusData.length > 0) {
      setSelectedTrailerStatusId(selectedTrailerStatusData[0]?.trailerStatusID);
      formStatusTrailer.setFieldsValue({
        trailerStatus: selectedTrailerStatusData[0]?.trailerStatusID,
      });
    }
  }, [selectedTrailerStatusData]);
  useEffect(() => {
    if (statusOptions) {
      formStatusTrailer.setFieldsValue({
        trailer1: status,
      });
      setSearchStatusId(status);
    }
  }, []);

  const getAllDropDownOptions = async () => {
    try {
      const { data } = await getAllLocationsEffect();

      const supplyOptions = [...new Set(data.map((row) => row.locationType).filter(Boolean))].map((locationType) => ({
        label: locationType,
        value: locationType,
      }));

      setSupplyZoneNumberOptions(supplyOptions);
    } catch (error) {
      console.error(error);
    }
  };

  const onTrailerIdSelectGetAll = (e) => {
    const trailerId = e?.value || '';
    setSelectedTrailerId(trailerId);
    getTrailerDataById(trailerId)
      .then((data) => {
        setSelectedTrailerData(data);
      })
      .catch((error) => {
        console.error('Error fetching trailer data:', error);
      });
  };

  const onTrailerIdSelectGetIssue = async (e) => {
    try {
      const trailerId = e?.value || '';
      if (trailerId) {
        setSelectedTrailerId(trailerId);
        const response = await getTrailerIssueDataById(trailerId);
        formIssueTrailer.setFieldsValue({
          notused: response[0].isOutOfService,
          issuetoReport: response[0].notInUseReason,
        });
        setTrailerNumber(response[0].trailerNumber);
        setIsOutOfService(response[0].isOutOfService);
        setSelectedTrailerNote(response[0].notInUseReason);
        setSelectedTrailerIssueData(response);
      } else {
        formIssueTrailer.setFieldsValue({
          notused: '',
          issuetoReport: '',
        });
        setTrailerNumber(0);
        setIsOutOfService('');
        setSelectedTrailerNote('');
      }
    } catch (error) {
      console.error('Error fetching trailer status data:', error);
    }
  };

  const onTrailerIdSelectGetStatus = (e) => {
    const trailerId = e?.value || '';
    setSelectedTrailerId(trailerId);
    getTrailerStatusDataById(trailerId)
      .then((data) => {
        setSelectedTrailerStatusData(data);
      })
      .catch((error) => {
        console.error('Error fetching trailer status data:', error);
      });
  };

  const onSelectFilterByTrailerNumber = (e) => {
    if (e) {
      setSearchTrailerId(e.value);
      onSearchClick(searchLocationId, e.value, searchStatusId, supplyZone, 'reset');
    } else {
      setSearchTrailerId('');
      onSearchClick(searchLocationId, '', searchStatusId, supplyZone, 'reset');
    }
  };

  const onSelectFilterBySupplyZone = (e) => {
    if (e) {
      setSupplyZone(e.value);
      onSearchClick(searchLocationId, searchTrailerId, searchStatusId, e.value, 'reset');
    } else {
      setSupplyZone('');
      onSearchClick(searchLocationId, searchTrailerId, searchStatusId, '', 'reset');
    }
  };

  const onSelectFilterByStatus = (e) => {
    if (e) {
      setSearchStatusId(e.value);
      onSearchClick(searchLocationId, searchTrailerId, e.value, supplyZone, 'reset');
    } else {
      setSearchStatusId('');
      onSearchClick(searchLocationId, searchTrailerId, '', supplyZone, 'reset');
    }
  };

  const onTrailerLocationIdSelect = (e) => {
    setSelectedTrailerLocationId(e.value);
  };

  const onTrailerYardSelect = (e) => {
    setSelectedTrailerYard(e.value);
  };

  const onUnitRentalCompanyIdSelect = (e) => {
    setSelectedUnitRentalCompanyId(e.value);
  };

  const onUnitSizeIdSelect = (e) => {
    setSelectedUnitSizeId(e.value);
  };

  const onStatusIdSelect = (e) => {
    setSelectedStatusId(e.value);
  };

  const onTrailerStatusIdSelect = (e) => {
    setSelectedTrailerStatusId(e.value);
  };

  const onTrailerNoteInput = (e) => {
    setSelectedTrailerNote(e.target.value);
  };
  const handleChange = () => {
    setIsOutOfService(!isOutOfService);
  };

  const onTrailerLocationSearch = (e) => {
    const locationId = e?.value || '';
    if (locationId) {
      setSearchLocationId(locationId);
      onSearchClick(locationId, searchTrailerId, searchStatusId, supplyZone, 'reset');
    } else {
      setSearchLocationId('');
      onSearchClick(locationId, searchTrailerId, searchStatusId, supplyZone, 'reset');
    }
  };

  const closeModal = () => {
    formNewTrailer.resetFields();
    setInputTrailerNumber('');
    setHidden(!hidden);
  };

  const closeUpdateTrailerModal = () => {
    formUpdateTrailer.resetFields();
    setSelectedFreightCarrierId('');
    setTempTrailerLocationIdOptions([]);
    setUpdateTrailerHidden(!updateTrailerHidden);
  };

  const CloseIssueModal = () => {
    formIssueTrailer.resetFields();
    setSelectedTrailerNote('');
    setIssueHidden(!issueHidden);
  };

  const CloseStatusModal = () => {
    formStatusTrailer.resetFields();
    setStatusHidden(!statusHidden);
  };

  const OpenTrailerPopup = () => {
    setHidden(true);
  };

  const OpenUpdateTrailerPopup = () => {
    setUpdateTrailerHidden(true);
  };

  const OpenReportPopup = () => {
    setIssueHidden(true);
  };

  const OpenTrailerStatusPopup = () => {
    setStatusHidden(true);
  };

  const getTrailerList = async () => {
    try {
      let requestParam = {};
      if (searchLocationId) {
        requestParam = { branchKey: searchLocationId, ...DEFAULT_PARAMS };
      }
      const { data } = await getTrailersListEffect(requestParam);
      const options = (
        isModal ? data.filter((row) => !row.isOutOfService && !excludedStatuses.includes(row.trailerStatusID)) : data
      ).reduce((acc, row) => {
        if (row.trailerNumber != null && row.trailerID != null && !acc.some((item) => item.value === row.trailerID)) {
          acc.push({ label: row.trailerNumber, value: row.trailerID });
        }
        return acc;
      }, []);
      setTrailerNumberOptions(options);
    } catch (error) {
      console.error(error);
      setTrailerNumberOptions([]);
    }
  };

  const getTrailerDataById = async (trailerId) => {
    try {
      const { data } = await getTrailersListEffect({ trailerId, ...DEFAULT_PARAMS });

      setSelectedTrailerData(data);
    } catch (error) {
      console.error(error);
      setSelectedTrailerData([]);
    }
  };

  const getTrailerIssueDataById = async (trailerId) => {
    try {
      const { data } = await getTrailersListEffect({ trailerId, ...DEFAULT_PARAMS });

      setSelectedTrailerIssueData(data);
      return data;
    } catch (error) {
      console.error(error);
      setSelectedTrailerIssueData([]);
    }
  };

  const getTrailerStatusDataById = async (trailerId) => {
    try {
      const { data } = await getTrailersListEffect({ trailerId, ...DEFAULT_PARAMS });

      setSelectedTrailerStatusData(data);
    } catch (error) {
      console.error(error);
      setSelectedTrailerStatusData([]);
    }
  };

  const getAllTrailerLocationID = async () => {
    try {
      const { data } = await getAllSupplyLocationIDEffect();

      let options = data
        .filter((row) => row.branchKey !== -1)
        .map((row) => ({
          label: row.branchDesc,
          value: row.branchKey,
        }));

      if (selectedTrailerLocationId) {
        options = options.filter((option) => option.value === selectedTrailerLocationId);
      }

      setTrailerLocationIdOptions(options);
    } catch (error) {
      console.error(error);
      setTrailerLocationIdOptions([]);
    }
  };

  const getAllUnitRentalCompanyID = async () => {
    try {
      const { data } = await getAllUnitRentalCompanyIdEffect();

      const options = data
        .filter((row) => row.id !== -1)
        .map((row) => ({
          label: row.name,
          value: row.id,
        }));
      setUnitRentalCompanyIdOptions(options);
    } catch (error) {
      console.error(error);
      setUnitRentalCompanyIdOptions([]);
    }
  };

  const getAllUnitSizeID = async () => {
    try {
      const { data } = await getAllNewUnitSizeIdEffect();

      const options = data
        .filter((row) => row.id !== -1)
        .map((row) => ({
          label: row.size,
          value: row.id,
        }));
      setUnitSizeIdOptions(options);
    } catch (error) {
      console.error(error);
      setUnitSizeIdOptions([]);
    }
  };

  const getAllYard = async () => {
    try {
      const { data } = await getAllYardEffect();

      const options = data
        .filter((row) => row.id !== -1)
        .map((row) => ({
          label: row.location,
          value: row.yardID,
        }));
      setTrailerYardOptions(options);
    } catch (error) {
      console.error(error);
      setTrailerYardOptions([]);
    }
  };

  const getAllTrailerStatus = async () => {
    try {
      const { data } = await getAllTrailerStatusEffect();

      const options = data
        .filter((row) => row.id !== -1)
        .map((row) => ({
          label: row.codeDesc,
          value: row.codeId,
        }));
      setTrailerStatusOptions(options);
    } catch (error) {
      console.error(error);
      setTrailerStatusOptions([]);
    }
  };

  const getAllStatus = async () => {
    try {
      const { data } = await getAllStatusEffect();

      const options = data
        .filter((row) => row.id !== -1)
        .map((row) => ({
          label: row.codeDesc,
          value: row.codeId,
        }));
      setStatusOptions(options);
    } catch (error) {
      console.error(error);
      setStatusOptions([]);
    }
  };

  const handleAddTrailer = () => {
    if (
      ValidateTrailerName() === true &&
      ValidateTrailerLocation() === true &&
      ValidateTrailerYard() === true &&
      ValidateUnitSize() === true &&
      ValidateRentalCompany() === true &&
      ValidateStatus() === true
    ) {
      dispatch(setAppLoader(true));
      const data = [
        {
          locationID: selectedTrailerLocationId,
          freightCarrierID: Number.parseInt(selectedFreightCarrierId),
          trailerNumber: inputTrailerNumber,

          freightCommodityID: Number.parseInt(selectedFreightCommodityId),
          unitRentalCompanyID: selectedUnitRentalCompanyId,
          unitSizeID: selectedUnitSizeId,
          yardID: selectedTrailerYard,
          status: selectedStatusId,
        },
      ];

      saveTrailer(data)
        .then(() => {
          dispatch(setAppLoader(false));
          setAlertMessage('Trailer added successfully');
          setAlertOpen(true);
          formNewTrailer.resetFields();
          setInputTrailerNumber('');

          getTrailerList();
          setHidden(false);

          onSearchClick(searchLocationId, searchTrailerId, searchStatusId, supplyZone, 'reset');
        })
        .catch((error) => {
          console.error('Trailer add failed:', error);
          dispatch(setAppLoader(false));
        });
    }
  };

  const handleUpdateTrailer = () => {
    dispatch(setAppLoader(true));
    const data = [
      {
        locationID: selectedTrailerLocationId,
        freightCarrierID: Number.parseInt(selectedFreightCarrierId),
        trailerNumber: inputTrailerNumber,
        freightCommodityID: Number.parseInt(selectedFreightCommodityId),
        unitRentalCompanyID: selectedUnitRentalCompanyId,
        unitSizeID: selectedUnitSizeId,
        yardID: selectedTrailerYard,
        status: selectedStatusId,
      },
    ];

    saveTrailer(data)
      .then(() => {
        dispatch(setAppLoader(false));
        setAlertMessage('Trailer updated successfully');
        setAlertOpen(true);
        formUpdateTrailer.resetFields();
        setInputTrailerNumber('');
        getTrailerList();
        setUpdateTrailerHidden(false);
        setTempTrailerLocationIdOptions([]);
        onSearchClick(searchLocationId, searchTrailerId, searchStatusId, supplyZone, 'reset');
      })
      .catch((error) => {
        console.error('Trailer update failed:', error);
        dispatch(setAppLoader(false));
      });
  };

  const handleAlertOk = () => {
    setAlertOpen(false);
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleUpdateTrailerStatus = () => {
    const data = [
      {
        trailerID: selectedTrailerId,
        trailerStatusID: selectedTrailerStatusId,
      },
    ];

    updateTrailerStatus(data)
      .then(() => {
        setAlertMessage('Trailer Status saved successfully');
        setAlertOpen(true);
        formStatusTrailer.resetFields();
        setStatusHidden(false);
        onSearchClick(searchLocationId, searchTrailerId, searchStatusId, supplyZone, 'reset');
      })
      .catch((error) => {
        console.error('Trailer Status saved failed:', error);
      });
  };

  const handleUpdateTrailerNote = async () => {
    try {
      if (!trailerNumber || (isOutOfService && !selectedTrailerNote)) {
        setAlertOpen(!alertOpen);
        setAlertMessage('All the fields are required');
        return;
      }
      const data = [
        {
          trailerNumber: String(trailerNumber || ''),
          notInUseReason: selectedTrailerNote,
          isOutOfService,
        },
      ];
      await updateTrailerNote(data);
      setAlertMessage('Trailer Issue saved successfully');
      setAlertOpen(true);

      formIssueTrailer.resetFields();
      setSelectedTrailerNote('');
      setIsOutOfService(false);
      setIssueHidden(false);
      setTrailerNumber(0);
      onSearchClick(searchLocationId, searchTrailerId, searchStatusId, supplyZone, 'reset');
    } catch (error) {
      console.error('Trailer Issue save failed:', error);
    }
  };

  const ValidateTrailerName = () => {
    if (!inputTrailerNumber) {
      setTrailerError('Trailer number required');
      return false;
    }
    if (inputTrailerNumber.length > 100) {
      setTrailerError('Trailer number length exceeds maximum limit');
      return false;
    }

    setTrailerError('');
    return true;
  };

  const ValidateTrailerLocation = () => {
    if (selectedTrailerLocationId !== '' && selectedTrailerLocationId !== undefined) {
      document.getElementById('errorTrailerLoc').innerHTML = '';
      return true;
    }
    document.getElementById('errorTrailerLoc').innerHTML = 'Select trailer location';
    return false;
  };

  const ValidateTrailerYard = () => {
    if (selectedTrailerYard !== '' && selectedTrailerYard !== undefined) {
      document.getElementById('errorTrailerYard').innerHTML = '';
      return true;
    }
    document.getElementById('errorTrailerYard').innerHTML = 'Select trailer yard';
    return false;
  };

  const ValidateUnitSize = () => {
    if (selectedUnitSizeId !== '' && selectedUnitSizeId !== undefined) {
      document.getElementById('errorUnitSize').innerHTML = '';
      return true;
    }
    document.getElementById('errorUnitSize').innerHTML = 'Select unit size';
    return false;
  };

  const ValidateRentalCompany = () => {
    if (selectedUnitRentalCompanyId !== '' && selectedUnitRentalCompanyId !== undefined) {
      document.getElementById('errorRentalComp').innerHTML = '';
      return true;
    }
    document.getElementById('errorRentalComp').innerHTML = 'Select rental company';
    return false;
  };

  const ValidateStatus = () => {
    if (selectedStatusId !== '' && selectedStatusId !== undefined) {
      document.getElementById('errorStatus').innerHTML = '';
      return true;
    }
    document.getElementById('errorStatus').innerHTML = 'Select status';
    return false;
  };

  return (
    <>
      <AlertModal
        title="Alert"
        open={alertOpen}
        description={alertMessage}
        onOk={handleAlertOk}
        onClose={handleAlertClose}
      />
      <Drawer
        width="40%"
        visible={hidden}
        headerContents={<PrimaryLabel className="text-white">Add Trailer</PrimaryLabel>}
        onClose={closeModal}
      >
        <div className="popup-body p-10">
          <Form form={formNewTrailer}>
            <Row gutter={20}>
              <Col sm={12}>
                <FormInput
                  name="GeneralSearch"
                  label="Trailer #"
                  margin="m-0"
                  editMode
                  value={inputTrailerNumber}
                  onChange={onTrailerNumberInput}
                  maxLength="100"
                />

                {trailerError && (
                  <div id="errorTrailer" className="text-danger">
                    {trailerError}
                  </div>
                )}
              </Col>

              <Col sm={12}>
                <FormSelectBox
                  label="New Trailer Location ID"
                  editMode
                  name="NewTrailerLocationId"
                  value={selectedTrailerLocationId}
                  margin="m-0"
                  placeholder="New Trailer Location ID"
                  options={trailerLocationIdOptions}
                  onChange={onTrailerLocationIdSelect}
                />
                <div id="errorTrailerLoc" className="text-danger" />
              </Col>
            </Row>

            <Row gutter={20}>
              <Col sm={12}>
                <FormSelectBox
                  label="New Trailer Yard"
                  editMode
                  name="NewTrailerYard"
                  value={selectedTrailerYard}
                  margin="m-0"
                  placeholder="New Trailer Yard"
                  options={trailerYardOptions}
                  onChange={onTrailerYardSelect}
                />
                <div id="errorTrailerYard" className="text-danger" />
              </Col>

              <Col sm={12}>
                <FormSelectBox
                  label="New Unit Rental Company Id"
                  editMode
                  name="NewUnitRentalCompanyId"
                  value={selectedUnitRentalCompanyId}
                  margin="m-0"
                  placeholder="New Unit Rental Company Id"
                  options={unitRentalCompanyIdOptions}
                  onChange={onUnitRentalCompanyIdSelect}
                />
                <div id="errorRentalComp" className="text-danger" />
              </Col>
            </Row>

            <Row gutter={20}>
              <Col sm={12}>
                <FormSelectBox
                  label="New Unit Size Id"
                  editMode
                  name="NewUnitSizeId"
                  value={selectedUnitSizeId}
                  margin="m-0"
                  placeholder="New Unit Size Id"
                  options={unitSizeIdOptions}
                  onChange={onUnitSizeIdSelect}
                />
                <div id="errorUnitSize" className="text-danger" />
              </Col>

              <Col sm={12}>
                <FormSelectBox
                  label="Status"
                  editMode
                  name="AddStatus"
                  value={selectedStatusId}
                  margin="m-0"
                  placeholder="Status"
                  options={statusOptions}
                  onChange={onStatusIdSelect}
                />
                <div id="errorStatus" className="text-danger" />
              </Col>
            </Row>

            <Row gutter={20}>
              <Col sm={12} className="col text-center mt-25">
                <button type="button" className="btn btn-dipblue" onClick={handleAddTrailer}>
                  {' '}
                  Create a new trailer{' '}
                </button>
              </Col>
            </Row>
          </Form>
        </div>
      </Drawer>

      <Drawer
        width="40%"
        visible={updateTrailerHidden}
        headerContents={<PrimaryLabel className="text-white">Update Trailer</PrimaryLabel>}
        onClose={closeUpdateTrailerModal}
      >
        <div className="popup-body p-10">
          <Form form={formUpdateTrailer}>
            <Row gutter={20}>
              <Col sm={12}>
                <FormSelectBox
                  label="Trailer #"
                  editMode
                  name="UpdateTrailer"
                  value={inputTrailerNumber}
                  margin="m-0"
                  placeholder="Trailer #"
                  options={trailerNumberOptions}
                  onChange={onTrailerIdSelectGetAll}
                />
              </Col>

              <Col sm={12}>
                <FormSelectBox
                  label="Trailer Location ID"
                  editMode
                  name="UpdateTrailerLocationId"
                  value={selectedTrailerLocationId}
                  margin="m-0"
                  placeholder="Trailer Location ID"
                  options={tempTrailerLocationIdOptions}
                  onChange={onTrailerLocationIdSelect}
                />
              </Col>
            </Row>

            <Row gutter={20}>
              <Col sm={12}>
                <FormSelectBox
                  label="Trailer Yard"
                  editMode
                  name="UpdateTrailerYard"
                  value={selectedTrailerYard}
                  margin="m-0"
                  placeholder="Trailer Yard "
                  options={trailerYardOptions}
                  onChange={onTrailerYardSelect}
                />
              </Col>

              <Col sm={12}>
                <FormSelectBox
                  label="Unit Rental Company Id"
                  editMode
                  name="UpdateUnitRentalCompanyId"
                  value={selectedUnitRentalCompanyId}
                  margin="m-0"
                  placeholder="Unit Rental Company Id "
                  options={unitRentalCompanyIdOptions}
                  onChange={onUnitRentalCompanyIdSelect}
                />
              </Col>
            </Row>

            <Row gutter={20}>
              <Col sm={12}>
                <FormSelectBox
                  label="Unit Size Id"
                  editMode
                  name="UpdateUnitSizeId"
                  value={selectedUnitSizeId}
                  margin="m-0"
                  placeholder="Unit Size Id "
                  options={unitSizeIdOptions}
                  onChange={onUnitSizeIdSelect}
                />
              </Col>

              <Col sm={12}>
                <FormSelectBox
                  label="Status"
                  editMode
                  name="UpdateStatus"
                  value={selectedStatusId}
                  margin="m-0"
                  placeholder="Status "
                  options={statusOptions}
                  onChange={onStatusIdSelect}
                />
              </Col>
            </Row>

            <Row gutter={20}>
              <Col sm={12} className="text-center mt-25">
                <button type="button" className="btn btn-dipblue" onClick={handleUpdateTrailer}>
                  {' '}
                  Update trailer{' '}
                </button>
              </Col>
            </Row>
          </Form>
        </div>
      </Drawer>

      <Drawer
        width="40%"
        visible={issueHidden}
        headerContents={<PrimaryLabel className="text-white">Issue to Report</PrimaryLabel>}
        onClose={CloseIssueModal}
      >
        <div className="popup-body p-10">
          <Form form={formIssueTrailer}>
            <Row gutter={20}>
              <Col sm={12}>
                <FormSelectBox
                  label="Trailer #"
                  editMode
                  name="IssueTrailerNumber"
                  margin="m-0"
                  options={trailerNumberOptions}
                  onChange={onTrailerIdSelectGetIssue}
                />
              </Col>
              <Col sm={12} className="d-flex align-items-end">
                <FormCheckBox
                  checkBoxClass="normal-checkbox"
                  label="Not Used"
                  name="notused"
                  checked={isOutOfService}
                  className="mt-24"
                  onChange={handleChange}
                />
              </Col>
              <Col sm={12}>
                <FormTextArea
                  editMode
                  name="issuetoReport"
                  margin="mb-14"
                  label="Issue to Report"
                  placeholder="Issue to Report"
                  enableAutoFocus={false}
                  rows={3}
                  onChange={onTrailerNoteInput}
                />
              </Col>
            </Row>

            <Row gutter={20}>
              <Col sm={24} className="text-center mt-5">
                <button type="button" className="btn btn-dipblue" onClick={handleUpdateTrailerNote}>
                  {' '}
                  Submit Report{' '}
                </button>
              </Col>
            </Row>
          </Form>
        </div>
      </Drawer>

      <Drawer
        width="40%"
        visible={statusHidden}
        headerContents={<PrimaryLabel className="text-white">Update Trailer Status</PrimaryLabel>}
        onClose={CloseStatusModal}
      >
        <div className="popup-body p-10">
          <Form form={formStatusTrailer}>
            <Row gutter={20}>
              <Col sm={12}>
                <FormSelectBox
                  label="Trailer #"
                  editMode
                  name="StatusTrailerNumber"
                  margin="m-0"
                  placeholder="Trailer #"
                  options={trailerNumberOptions}
                  onChange={onTrailerIdSelectGetStatus}
                />
              </Col>

              <Col sm={12}>
                <FormSelectBox
                  label="CT Trailer Status"
                  editMode
                  name="trailerStatus"
                  value={selectedTrailerStatusId}
                  margin="m-0"
                  placeholder="CT Trailer Status"
                  options={trailerStatusOptions}
                  onChange={onTrailerStatusIdSelect}
                />
              </Col>
            </Row>

            <Row gutter={20}>
              <Col sm={24} className="text-center mt-5">
                <button type="button" className="btn btn-dipblue" onClick={handleUpdateTrailerStatus}>
                  {' '}
                  Submit{' '}
                </button>
              </Col>
            </Row>
          </Form>
        </div>
      </Drawer>

      <Row gutter={20}>
        {!isModal && (
          <>
            <Col className="mt-25">
              <button type="button" className="btn btn-dipblue" onClick={OpenReportPopup}>
                {' '}
                Report an Issue{' '}
              </button>
            </Col>

            <Col className="mt-25">
              <button type="button" onClick={OpenTrailerPopup} className="btn btn-dipblue">
                {' '}
                Add a New Trailer{' '}
              </button>
            </Col>

            <Col className="mt-25">
              <button type="button" onClick={OpenUpdateTrailerPopup} className="btn btn-dipblue">
                {' '}
                Update Trailer{' '}
              </button>
            </Col>

            <Col className="mt-25">
              <button type="button" onClick={OpenTrailerStatusPopup} className="btn btn-dipblue">
                {' '}
                Update Trailer Condition Status{' '}
              </button>
            </Col>
          </>
        )}
        <Col flex={1}>
          <Row gutter={20}>
            <Col sm={5}>
              <TrailerStoreIdSelector
                label="Filter by Location"
                editMode
                name="sz2"
                margin="m-0"
                placeholder="Location #"
                onChange={onTrailerLocationSearch}
                params={searchLocationId ? `?branchKey=${searchLocationId}` : ''}
              />
            </Col>

            <Col sm={5}>
              <FormSelectBox
                label="Filter by Status"
                editMode
                name="trailer1"
                margin="m-0"
                placeholder="Status"
                defaultValue={status}
                options={statusOptions}
                onChange={onSelectFilterByStatus}
              />
            </Col>

            <Col sm={5}>
              <FormSelectBox
                label="Filter by Trailer #"
                editMode
                name="trailerNumber"
                margin="m-0"
                placeholder="Trailer #"
                asyncFetchMode
                onChange={onSelectFilterByTrailerNumber}
                asyncFunction={async (params) => {
                  const requestParams = {
                    trailerNumber: params.SearchValue,
                  };
                  const { data } = await getTrailersListEffect({ ...DEFAULT_PARAMS, ...requestParams });
                  const options = data.map((row) => ({
                    label: row.trailerNumber,
                    value: row.trailerID,
                  }));
                  return { data: options };
                }}
                searchParamName="SearchValue"
                searchParamMinLength={3}
              />
            </Col>

            <Col sm={5}>
              <TrailerStoreIdSelector
                label="Filter by Supply Zone Number"
                editMode
                name="SzNumber"
                placeholder="SupplyZone Number"
                isIDSelector={false}
                onChange={onSelectFilterBySupplyZone}
                options={supplyZoneNumberOptions}
              />
            </Col>

            <Col sm={4}>
              <FormInput
                name="GeneralSearch"
                label="General Search"
                margin="m-0"
                editMode
                onChange={onChangeGeneralSearch}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default TrailerSearch;
